import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import Cookies from 'js-cookie';

const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    authorization: Cookies.get('pg_jwt') || '',
  },
}));

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_PG_MONOLITH_HOST}/api/amalyrics/graph`,
  fetch,
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
